module.exports = __webpack_public_path__ + "img/VND.ff61166cb.svg";